import script from "./CardComposition.vue?vue&type=script&setup=true&lang=js"
export * from "./CardComposition.vue?vue&type=script&setup=true&lang=js"

import "./CardComposition.vue?vue&type=style&index=0&id=6f1488e5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f1488e5"]])

export default __exports__